<template>
    <div>
        <van-cell-group>
            <van-cell title='购物车' is-link to='' v-model="shoppingCar" @click="goshopCar">
            </van-cell>
            <van-cell title='待付款' is-link to='' v-model="unpay" @click="gounpay">
            </van-cell>
            <van-cell title='待预约' is-link to='' v-model="pay" @click="gopay">
            </van-cell>
            <van-cell title='待体检' is-link to='' v-model="order" @click="goorder">
            </van-cell>
            <van-cell title='体检中' is-link to='' v-model="start" @click="gostart">
            </van-cell>
            <van-cell title='已完成' is-link to='' v-model="finish" @click="gofinish">
            </van-cell>
            <!-- <van-cell title='团检订单' is-link to='user/orderTuan' value='12'>
                    </van-cell> -->
        </van-cell-group>
    </div>
</template>

<script>
    import api from "@/fetch/api";
    import {
        mapGetters
    } from 'vuex';
    import {
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                shoppingCar: 0,
                unpay: 0,
                pay: 0,
                order: 0,
                start: 0,
                finish: 0
            }
        },
        created() {
            window.scroll(0, 0);
            let CUSTOMER_ID = this.userInfo.CUSTOMER_ID;
            api.searchOrder(CUSTOMER_ID).then(res => {
                let data = res.data;
                console.log(data);
                this.shoppingCar = (data.shoppingCar == undefined ? 0 : data.shoppingCar);
                this.unpay = (data.unpay == undefined ? 0 : data.unpay);
                this.pay = (data.pay == undefined ? 0 : data.pay);
                this.order = (data.order == undefined ? 0 : data.order);
                this.start = (data.start == undefined ? 0 : data.start);
                this.finish = (data.finish == undefined ? 0 : data.finish);
            });
        },
        computed: {
            ...mapGetters(["userInfo"])
        },
        methods: {
            goshopCar() {
                if (this.shoppingCar > 0) {
                    this.$router.push('user/shopcart');
                } else {
                    Toast.fail({
                        message:'您的购物车中没有订单',
                        duration: 1000
                    })
                }
            },
            gounpay() {
                if (this.unpay > 0) {
                    this.$router.push('user/orderPay');
                } else {
                    Toast.fail({
                        message:'您没有待付款订单',
                        duration: 1000
                    })
                }
            },
            gopay() {
                if (this.pay > 0) {
                    this.$router.push('user/orderYuYue');
                } else {
                    Toast.fail({
                        message:'您没有待预约订单',
                        duration: 1000
                    })
                }
            },
            goorder() {
                if (this.order > 0) {
                    this.$router.push('user/orderTJ');
                } else {
                    Toast.fail({
                        message:'您没有待体检订单',
                        duration: 1000
                    })
                }
            },
            gostart() {
                if (this.start > 0) {
                    this.$router.push('user/orderStart');
                } else {
                    Toast.fail({
                        message:'您没有体检中订单',
                        duration: 1000
                    })
                }
            },
            gofinish() {
                if (this.finish > 0) {
                    this.$router.push('user/orderFinish');
                } else {
                    Toast.fail({
                        message:'您没有已完成订单',
                        duration: 1000
                    })
                }
            }
        }
    }
</script>

<style scoped lang='less'>
    .van-cell {
        // border-left: 3px;
        border-left: 0px;
        border-style: solid;
        border-color: #99C51D;
        border-top: 0px;
        border-right: 0px;
        border-bottom: 0px;
        margin-bottom: 2px;
        padding: 20px 15px;
        font-size: 1rem;
        font-family: "Microsoft YaHei";
    }
    .van-cell:not(:last-child)::after {
        left: 0;
    }
    .van-tag--danger {
        background: #AC9C70;
    }
</style>


// WEBPACK FOOTER //
// src/pages/shoplist.vue